module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.a2b049ba.png";